import { Check } from 'iconoir-react';
import { FC } from 'react';
import styled from 'styled-components';

const Container = styled.button`
  width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.theme.colors.pri500};
  cursor: pointer;
  border-radius: 4px;
  margin-right: -0.8px;
  height: auto;
  margin-top: -0.6px;
  z-index: 1000000000000000;
  margin-bottom: -0.5px;
  border: none;
`;

interface IndicatorsContainerProps {
  selectProps: {
    onSubmit: (value: any) => void;
    value: any;
  };
}

export const IndicatorsContainer: FC<IndicatorsContainerProps> = ({
  selectProps
}) => (
  <Container
    data-testid='button'
    onMouseDown={event => {
      event.preventDefault();
      event.stopPropagation();
    }}
    onClick={() => {
      selectProps?.onSubmit(selectProps.value);
    }}
  >
    <Check color='white' />
  </Container>
);
